<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>

<script>
import { mapState, mapActions } from 'vuex'
import MetaHeader from '@/components/layout/MetaHeader'
import LatestPostsTVSlidePreviews from '@/components/modules/LatestPostsTVSlidePreviews'

export default {
  name: 'LatestPostsTV',
  components: {
    MetaHeader,
    LatestPostsTVSlidePreviews,
  },
  computed: {
    ...mapState('bubbletool', ['latestPostTV']),
    cleanedLatestPostTv() {
      const imageRegex = /(^image)(\/)[a-zA-Z0-9_]*/
      return this.latestPostTV.filter(elem => {
        return (elem.id && (elem.id.split('-')[0] === 'post')) ||
               (elem.mimetype && (imageRegex.exec(elem.mimetype))
        )
      })
    },
  },
  created() {
    this.checkForNewPosts()
  },
  methods: {
    ...mapActions('bubbletool', [ 'getLatestPostsTv' ]),
    checkForNewPosts() {
      this.getLatestPostsTv().then(() => {
        setTimeout(this.checkForNewPosts, 30000 * this.cleanedLatestPostTv.length)
      })
    },
  },
}
</script>
